<template>
  <header class="site-header header-s1 is-sticky">
    <Menu />
    <div
      id="slider"
      class="banner banner-slider"
    >

      <div v-if="$route.name !== 'contact'">
        <slider
          animation="fade"
          height="450px"
          :duration="5000"
          :speed="1000"
          :control-btn="false"
          :indicators="false"
        >
          <slider-item>
            <div class="item">
              <div class="fill fill1">
                <div class="container">
                  <div class="row">
                    <div class="col-xs-8 col-xs-offset-2">
                      <form v-on:submit.prevent="">
                        <div class="input-group">
                          <div class="input-group-btn search-panel">
                            <!-- <select
                              class="btn btn-default"
                              v-model="search.selected_company"
                            >
                              <option
                                v-for="company in companies"
                                v-bind:value="company.id"
                              >{{company.company_name}}</option>
                            </select> -->
                          </div>
                          <!-- <input
                            type="hidden"
                            name="search_param"
                            value="all"
                            id="search_param"
                          />
                          <input
                            @input="filterJobs"
                            v-model="search.query"
                            type="text"
                            class="form-control"
                            name="x"
                            placeholder="Search job listings..."
                            autocomplete="off"
                          /> -->
                        </div>
                      </form>
                      <div
                        class="results"
                        v-show="search.query.length > 0"
                      >
                        <ul>
                          <li v-for="opening in openings"><a
                              v-bind:href="'application/' + opening.id"
                              v-html="opening.role_name"
                            ></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slider-item>
          <slider-item>
            <div class="fill fill2">
              <div class="container">
                <div class="row">
                  <div class="col-xs-8 col-xs-offset-2">
                    <form v-on:submit.prevent="">
                      <div class="input-group">
                        <!-- <div class="input-group-btn search-panel">
                          <select
                            class="btn btn-default"
                            v-model="search.selected_company"
                          >
                            <option
                              v-for="company in companies"
                              v-bind:value="company.id"
                            >{{company.company_name}}</option>
                          </select>
                        </div> -->
                        <!-- <input
                          type="hidden"
                          name="search_param"
                          value="all"
                          id="search_param"
                        />
                        <input
                          @input="filterJobs"
                          v-model="search.query"
                          type="text"
                          class="form-control"
                          name="x"
                          placeholder="Search job listings..."
                          autocomplete="off"
                        /> -->
                      </div>
                    </form>
                    <div
                      class="results"
                      v-show="search.query.length > 0"
                    >
                      <ul>
                        <li v-for="opening in openings"><a
                            v-bind:href="'application/' + opening.id"
                            v-html="opening.role_name"
                          ></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slider-item>
        </slider>
      </div>
    </div>

  </header>

</template>
<style scoped>
.fill1 {
  background-image: url("../assets/img/sundry_bg.jpg");
  background-attachment: fixed;
}
.fill2 {
  background-image: url("../assets/img/sundry_b1g.jpg");
  background-attachment: fixed;
}
.input-group {
  display: block !important;
  margin-top: 300px;
}
.input-group input {
  height: 44.8px !important;
  font-size: 14px !important;
  border-radius: 0px !important;
}
.input-group select {
  height: 44.8px !important;
  border-radius: 0px !important;
}
.input-group .btn-default:focus {
  background: #ffa01b;
  border: 2px solid #ffa01b !important;
  outline: 0 !important;
  color: #fff;
}
.results {
  position: absolute;
  display: block;
  background-color: #fff !important;
  width: 96.1%;
  padding: 5px;
  max-height: 200px;
  overflow-y: auto;
}
.results ul li {
  padding: 10px;
}
</style>
<script>
import Menu from './Menu'
export default {
  name: 'Header',
  data () {
    return {
      typewriter_settings: {
        header_text: "",
        text: "Explore a career in Sundry",
        speed: 100,
        counter: 0
      },
      companies: [
        {
          id: '0',
          company_name: 'Select company...'
        }
      ],
      search: {
        selected_company: '0',
        selected_company_error: false,
        query: ''
      },
      openings: [
        {
          id: '',
          role_name: 'Searching...'
        }
      ]
    }
  },
  mounted () {
    this.getCompanies()
  },
  components: {
    Menu
  },
  methods: {
    typeWriter: function () {

      var text = this.typewriter_settings.text
      var speed = this.typewriter_settings.speed


      if (this.typewriter_settings.counter < text.length) {
        this.typewriter_settings.header_text += text.charAt(this.typewriter_settings.counter)
        this.typewriter_settings.counter++
        setTimeout(this.typeWriter, speed)
      }
    },

    filterJobs (e) {
      var input = e.target.value
      this.search.query = input
      //console.log(e)

      if (input.length > 0) {
        if (this.search.selected_company == '0') {
          this.search.selected_company_error = true
          this.openings[0].role_name = "Please select a company to search..."
        } else {
          this.search.selected_company_error = false
          this.getJobsByParams(this.search.selected_company, this.search.query)
        }
      }
    },

    getJobsByParams (company_id, query) {
      var search_jobs = {
        what: 'SearchJobs',
        params: {
          company_id: company_id,
          q: query
        }
      }

      this.$socket.makeGetRequest(search_jobs)
        .then((response) => {
          if (response.type == 'SearchJobs') {
            if (response.data.length > 0) {
              this.openings = response.data
            } else {
              this.openings = [{
                role_name: 'No openings found for <i><b>"' + query + '"</b></i>'
              }]
            }

          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    getCompanies () {
      var companies = {
        what: 'Companies'
      }

      this.$socket.makeGetRequest(companies)
        .then((response) => {
          if (response.type == "Companies") {
            console.log(response.data)
            for (var i = 0; i < response.data.length; i++) {
              this.companies.push(response.data[i])
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }

  }
}
</script>